export const GET_HOME_MENU = 'GET_HOME_MENU'
export const SET_HOME_RESTAURANT_MENU = 'SET_HOME_RESTAURANT_MENU'

export const UPDATE_HOME_MENU = 'UPDATE_HOME_MENU'

export const UPDATE_HOME_MENU_SEARCH_INFO = 'UPDATE_SEARCH_INFO'
